import * as Popper from "popper.js";
import * as React from 'react';
import { DateTimePicker } from "../datetime-picker/DateTimePicker";
import { InputFeedback } from './InputFeedback';
import { InputLabel } from './InputLabel';
import { TimePicker } from "../time-picker/TimePicker";

// #region Component Props

interface IProps {
    id                  : string;
    label               : string;
    value               : any;
    onChange            : any;
    className?          : string;
    error?              : string;
    disable?            : boolean;
    format?             : string;
    showInlineLabels?   : boolean;

    readOnly?           : boolean;
    highlightDates?     : Date[];

    maxDate?            : Date;
    minDate?            : Date;
    
    maxTime?            : Date;    
    minTime?            : Date;
    
    includeDates?       : Date[];
    excludeDates?       : Date[];
    
    includeTimes?       : Date[];
    excludeTimes?       : Date[];

    startDate?          : Date;
    endDate?            : Date;

    inline?             : boolean;
    withPortal?         : boolean;
    popperModifiers?    : Popper.Modifiers;
}

// #endregion

const TimeInput : React.SFC<IProps> = (props) => {

    const { 
        className, 
        id, 
        error, 
        label, 
        value, 
        onChange, 
        disable,
        showInlineLabels
    } = props;

    return (
        <div className={'form-group ' + (className)}>
            <InputLabel htmlFor={id} error={error}>
                {label}
            </InputLabel>
            <TimePicker 
                dateValue={ value }
                classes="form-control"
                handleChange={ onChange }
                disable={ disable }
                showLabels={ showInlineLabels }
                {...props} />
            <InputFeedback error={error} />
        </div>
    );
};

TimeInput.defaultProps = {
    className        : '',
    error            : '',
    disable          : false,
    format           : '',
    showInlineLabels : false
};

export { TimeInput };
